// extracted by mini-css-extract-plugin
export default {"wrapper":"Pq2QtAbfB0iADtozuz4J"};